import React from 'react';
import { useHistory } from 'react-router-dom';
import Button from '../../components/Button';
import DropZone from '../../components/DropZone';
import Controller from '../../mixins/Controller';
import Page from '../../components/Page';
import PageHeader from '../components/PageHeader';
import FileNameRow from '../pages/FileNameRow';
import JobAttachmentController from '../controllers/JobAttachmentController';
import Form from '../../components/Form';
import Table from '../../components/Table';

const DocumnetUpload = (props) => {

    const handleFileUpload = (res) => {
        props.controller.uploadFile(res);
    }
    const FileLink = props.controller.state.filelink;
    const binder = props.binder;
    const controller = props.controller;
    const files = controller.state.files || [];
    const msg = files.length === 0 ? <Table.Row>
        <Table.Data></Table.Data>
        <Table.Data colSpan={7}>No Files Found</Table.Data>
    </Table.Row> : null;
    const rows = files.map(fc => {
        if (fc.state.file.recordStatus !== 'D') {
            return <FileNameRow key={fc.key} controller={fc} flag='J' link={FileLink}/>;
        }
    });
    const upload = <DropZone className='float-right' onDrop={handleFileUpload} multiple={false} disabled={controller.adding | controller.state.isSaveInProgress} style={{ borderStyle: 'none', padding: 'unset' }} width={200} height={50} >
        <Form.FieldHint hint='Drag &amp; Drop &rarr;' />&nbsp;
            <Button type='file' variant='success' size='sm' className='' icon='fa-upload' disabled={controller.adding | controller.state.isSaveInProgress} >Upload</Button>
    </DropZone>;

    return (
        <div>
            <div className='row mb-2'>
                <div className='col-6'><Form.Label name='Documents (Max. file size allowed is 25 MB)' /> </div>
                <div className='col-6'>{upload}</div>
            </div>
            <div className='row'>
                <div className='col-md-12' >
                    <Table id='documents'>
                        <Table.Header>
                            <Table.Row>
                                <Table.Head className='bg-primary table-dark col-action' />
                                <Table.Head className='bg-primary table-dark col-fileName'>Filename</Table.Head>
                                {/* <Table.Head className='bg-primary table-dark col-attachment'>Attachments</Table.Head>
                                <Table.Head className='bg-primary table-dark col-testName'>JobNumber</Table.Head>
                                <Table.Head className='bg-primary table-dark col-testName'>ServiceOrder</Table.Head>
                                <Table.Head className='bg-primary table-dark col-testName'>TestName</Table.Head> */}
                                <Table.Head className='bg-primary table-dark col-testName'>Uploaded By</Table.Head>
                                <Table.Head className='bg-primary table-dark col-dateTime'>Uploaded On</Table.Head>
                            </Table.Row>
                        </Table.Header>
                        <Table.Body>
                            {rows}
                            {msg}
                        </Table.Body>
                    </Table>
                </div>
            </div>
        </div>
    );
}


const Buttons = (props) => {

    let history = useHistory();

    const handleSave = () => {
        props.controller.save(() => {
            history.goBack();
        });
    }

    const handleClose = () => {
        history.goBack();
    }

    const controller = props.controller;
    return (
        <div className='col-md-12'>
            <div className='d-flex justify-content-end'>
                <Button icon='fa-save' id='btn-save' variant='primary' size='sm' className='action-button' disabled={controller.state.isSaveInProgress} onClick={handleSave}>Save</Button>
                <Button icon='fa-times' id='btn-cancel' variant='secondary' size='sm' className='action-button' onClick={handleClose}>Close</Button>
            </div>
        </div>
    );
}

const JobAttachmentPageHeader = (props) => <PageHeader title={props.pageTitle} showBackNavigation='true' />

class JobAttachmentPage extends React.Component {
    constructor(props, context) {
        super(props, context);

        Object.assign(this, Controller);
        const jobId = this.props.match.params.jobId;
        const jobNumber = this.props.match.params.jobNumber;
        this.props.controller.load(jobId, jobNumber);
    }

    static defaultProps = {
        controller: new JobAttachmentController()
    }

    componentDidMount = () => {
        this.initializeMixin();
    }

    render = () => {
        const binder = this.props.binder;
        const controller = this.props.controller;
        const buttons = controller.state.files.length !== 0
            ? <Buttons controller={controller} />
            : null;
        return (
            <Page {...this.props} pageTitle='InteServ · Asset Attachments' id='asset-attachments'>
                <JobAttachmentPageHeader pageTitle={'Job Attachments-' + controller.state.jobNumber} />
                <Page.Content>
                    <div className='row'>
                        <div className='col-12 job-attachments-content'>
                            <DocumnetUpload controller={controller} binder={binder} />
                        </div>
                        {/* {buttons} */}
                    </div>
                </Page.Content>
            </Page>
        );
    }
}

export default JobAttachmentPage;